import { Stack } from "@mui/material";
import { Button } from "components/ButtonNew";
import { SearchInput } from "components/Input";
import { useTranslation } from "react-i18next";

import type { TransientResultScenario } from "../lib/formatJobResults";

import { RESULT_KIND, type ResultKind } from "../model/constants";
import { TransientJobResultScenarioChips } from "./TransientJobResultScenarioChips";

type TransientJobResultToolbarProps = {
  activeKey: string;
  activeKind: ResultKind;
  disabled: boolean;
  onDownload: () => void;
  onSearch: (value: string) => void;
  onSelectKind: (kind: ResultKind) => void;
  onSelectScenario: (key: string) => void;
  scenarios: TransientResultScenario[];
  search: string;
};

export const TransientJobResultToolbar = ({
  activeKey,
  activeKind,
  disabled,
  onDownload,
  onSearch,
  onSelectKind,
  onSelectScenario,
  scenarios,
  search,
}: TransientJobResultToolbarProps) => {
  const { t } = useTranslation();
  return (
    <Stack className="mb-3 w-full justify-between gap-4">
      <TransientJobResultScenarioChips
        activeKey={activeKind}
        label={t("Execution.transient.jobDetails.resultKind")}
        onSelect={(key) => onSelectKind(key as ResultKind)}
        options={[
          { label: t("Execution.transient.jobDetails.roomResults"), name: RESULT_KIND.hourly },
          { label: t("Execution.transient.jobDetails.roomDictionary"), name: RESULT_KIND.dictionary },
        ]}
      />
      {scenarios.length > 0 ? (
        <TransientJobResultScenarioChips
          activeKey={activeKey}
          label={t("Execution.transient.jobDetails.scenarios")}
          onSelect={onSelectScenario}
          options={scenarios.map((scenario) => ({ name: scenario.name }))}
        />
      ) : null}
      <Stack className="shrink-0 items-center gap-3">
        <SearchInput
          debounceTime={300}
          height="4rem"
          label={t("Execution.transient.jobDetails.searchRooms")}
          onChange={(event) => onSearch(event.target.value)}
          type="search"
          value={search}
          width="22rem"
        />
        <Button disabled={disabled} height="4rem" onClick={onDownload} startIconName="Download" variant="secondary">
          {t("Execution.transient.jobDetails.downloadSelected")}
        </Button>
      </Stack>
    </Stack>
  );
};
